module.exports = __webpack_public_path__ + "img/sofyre-timeline.c743df6b.png";